import React, { useEffect } from 'react';
import { withRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import Section from 'components/core/Section';
import Text from 'components/core/Text';
import ActivityWidget from 'containers/Pages/Activities/ActivityWidget';
import ScheduledActivitiesList from 'components/ScheduledActivitiesList';
import useActivities from 'hooks/useActivities';
import AddProducts from 'components/AddProducts';
import { fetchPrograms } from 'actions/programs';
import { requestFetchAchievements } from 'actions/achievements';
import { requestAnnouncement } from 'actions/advertisement';
import { fetchUser, updateUser } from 'actions/user';
import PageLoader from 'components/PageLoader';
import AnnouncementBar from 'components/AnnouncementBar';
import Greeting from 'components/Greeting';
import StreakWidget from 'components/StreakWidget';
import sortPrograms from '../../../../utils/sortPrograms';
import Container from '../Container';
import PurchasedPrograms from '../../../PurchasedPrograms';
import SessionInfo from '../../../SessionInfo';
import { Wrapper } from '../../../../constants/globalStyles';

function Content({
  router,
  programs,
  showModal,
  lastUserWorkoutSessionDate,
  clearExercisesState,
  isResumingSession,
  getProductDataRequest,
}) {
  const dispatch = useDispatch();
  const featuredProgram = programs?.total ? sortPrograms(programs.all)[0] : {};
  const { futureActivities } = useActivities();
  const isProgramsLoading = useSelector((state) => state.programs.loading);
  const user = useSelector((state) => state.user);
  const announcement = useSelector((state) => state.advertisement.announcement);

  useEffect(() => {
    dispatch(fetchUser());
    dispatch(fetchPrograms());
    dispatch(requestFetchAchievements());
    dispatch(requestAnnouncement());
  }, [dispatch]);

  useEffect(() => {
    const productId = router.query?.['purchased-product'];
    if (productId) {
      getProductDataRequest({ productId });
    }
  }, [router.query, getProductDataRequest]);

  const handleAnnouncementClose = () => {
    dispatch(
      updateUser({
        data: {
          settings: {
            ...user.settings,
            showAnnouncement: false,
          },
        },
      }),
    );
  };

  return (
    <Wrapper>
      {/* No <Section> wrapper: its margin would survive the greeting's collapse and leave a
          gap behind. Greeting owns the space it occupies, and gives all of it back. */}
      <Container>
        <Greeting />
      </Container>
      {user.settings?.showAnnouncement && announcement && (
        <Section fillViewport={false} mb={4}>
          <Container>
            <AnnouncementBar
              message={announcement.message}
              linkText="Check it out"
              linkUrl="/programs/new"
              onClose={handleAnnouncementClose}
            />
          </Container>
        </Section>
      )}
      {isProgramsLoading ? (
        <PageLoader />
      ) : (
        !!programs?.total && (
          <Section fillViewport={false} mb={4} pb={6}>
            <PurchasedPrograms
              clearExercisesState={clearExercisesState}
              programs={programs}
              lastUserWorkoutSessionDate={lastUserWorkoutSessionDate}
              isResumingSession={isResumingSession}
              showModal={showModal}
            />

            <Container>
              <SessionInfo program={featuredProgram} schedule={featuredProgram.schedule} />
            </Container>
          </Section>
        )
      )}
      {!!futureActivities.length && (
        <Section fillViewport={false} mb={4} py={6}>
          <Container>
            <Text variant="sectionHeader" transform="uppercase" mb={4}>
              Scheduled sessions
            </Text>
            <ScheduledActivitiesList list={futureActivities.reverse()} />
          </Container>
        </Section>
      )}
      <Section fillViewport={false} mb={4} py={6}>
        <Container>
          <StreakWidget />
        </Container>
      </Section>
      <Section fillViewport={false} mb={4} py={6}>
        <Container>
          <ActivityWidget withColumns />
        </Container>
      </Section>
      <AddProducts />
    </Wrapper>
  );
}

export default withRouter(Content);
